import api from './api';

// Talks to /api/requested-stock-codes/* — the staging queue between a planner
// hitting a missing component on the BOM page and procurement creating the real
// item master record.
//
// Version and site travel in the request headers (set by the api interceptor),
// so `create` only sends what the planner typed plus the BOM context.
export const requestedStockService = {
  // status: 'PENDING' (default) | 'APPROVED' | 'REJECTED' | 'ALL'
  list: async (status) => {
    const res = await api.get('/requested-stock-codes', {
      params: status ? { status } : {},
    });
    return res.data;
  },

  // Just the pending number, for the alert badge on the Purchase landing page.
  countPending: async () => {
    const res = await api.get('/requested-stock-codes/count');
    return res.data;
  },

  // payload: { stock_code, description, unit_of_measure?, item_type?,
  //            product_class?, supplier_code?, notes?,
  //            parent_code?, qty_per?, scrap_pct? }
  create: async (payload) => {
    const res = await api.post('/requested-stock-codes', payload);
    return res.data;
  },

  // Partial — only the fields sent are written. Pending requests only.
  update: async (id, patch) => {
    const res = await api.put(`/requested-stock-codes/${id}`, patch);
    return res.data;
  },

  // Creates the md_stock_codes record and closes the request (and adds the BOM
  // line the planner was after, when the request still carries that context).
  approve: async (id) => {
    const res = await api.post(`/requested-stock-codes/${id}/approve`);
    return res.data;
  },

  reject: async (id, reviewNote) => {
    const res = await api.post(`/requested-stock-codes/${id}/reject`, {
      review_note: reviewNote || null,
    });
    return res.data;
  },

  remove: async (id) => {
    const res = await api.delete(`/requested-stock-codes/${id}`);
    return res.data;
  },
};

export default requestedStockService;
